/* eslint-disable no-nested-ternary */
import { h } from "preact";
import { useEffect, useState } from "preact/hooks";

import IconChecked from "../Icons/IconChecked";
import IconUnchecked from "../Icons/IconUnchecked";
import classname from "../../foundation/utils/classname";

import "./style.css";

interface Props {
    class?: string;
    checked?: boolean;
    disabled?: boolean;
    round?: boolean;
    onChange: (event: Event) => void;
    partialSelect?: boolean;
    [rest: string]: unknown;
}

export default function Checkbox(props: Props) {
    const {
        class: cssClass,
        partialSelect,
        round,
        checked,
        onChange,
        ...inputProps
    } = props;
    const [isChecked, setIsChecked] = useState(checked);

    const handleChange = (e: Event) => {
        setIsChecked((e.target as HTMLInputElement).checked);
        onChange?.(e);
    };

    useEffect(() => {
        if (isChecked !== checked) {
            setIsChecked(checked);
        }
    }, [checked]);

    return (
        <div class={classname("checkboxComponent", cssClass, { partialSelect, round })}>
            {h("input", Object.assign(inputProps, { onChange: handleChange, checked, type: "checkbox" }))}
            {(round || partialSelect) ? (
                <div class="indicator"/>
            ) : (
                isChecked ? <IconChecked color="var(--checkbox-checked-state-color)"/> : <IconUnchecked color="var(--checkbox-initial-state-color)"/>
            )}
        </div>
    );
}
